var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signup"},[_c('signup-title'),_c('input-id'),_c('input-password'),_c('button-signup')],1)}
var staticRenderFns = []

export { render, staticRenderFns }